import { useEffect, useRef, useState } from 'react';
import {
  EnvironmentOutlined,
  ArrowLeftOutlined,
  LineChartOutlined,
  StarOutlined,
  StarFilled,
  DeleteOutlined,
  PlusCircleOutlined,
  EyeOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import {
  Badge,
  Button,
  Card,
  Form,
  notification,
  Select,
  Tag,
  Tooltip,
  Modal as ModalAnt,
} from 'antd';

import InfraestructureContext from '@/contexts/InfraestructureContext';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import InfrastructureService from '../../../domain/Infrastructure/InfraestructureService';
import { connect } from 'react-redux';
import DigitalTwinService from '../../../domain/DigitalTwin/DigitalTwinService';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import Step1 from './Modal/Step1';
import Step2 from './Modal/Step2';
import UploadHydroTwinStep from './Modal/UploadHydroTwinStep';
import UploadHydroTwinFilesStep from './Modal/UploadHydroTwinFilesStep';
import SelectInpFile from '@/basicsComponents/Selects/SelectInpFile';
import InpService from '../../../domain/ModelFile/InpService';
import { DigitalTwin } from '@/domain/DigitalTwin/DigitalTwin';
import dayjs from 'dayjs';
import SelectModelInfrastructure from '@/basicsComponents/Selects/SelectModelInfrastructure';
import SelectAsset from '@/basicsComponents/Selects/SelectAsset';

const infrastructureService = new InfrastructureService();
const digitalTwinService = new DigitalTwinService();
const inpService = new InpService();

function ParamSelfCalibrationView({ digitalTwinData }: any) {
  const security = localStorage.getItem('security');
  const organizationId = JSON.parse(security || '{}').organizationId;
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const [calibrations, setCalibrations] = useState<any[]>([]);
  const [showNewNeuralNetwork, setShowNewNeuralNetwork] = useState(false);
  const [showNeuralGraph, setShowNeuralGraph] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [dataGraph, setDataGraph] = useState({});
  const [graphOptions, setGraphOptions] = useState({});
  const [newDigitalTwinData, setNewDigitalTwinData] = useState<any>(null);
  const [form] = Form.useForm();
  const [modelInfraIdList, setModelInfraIdList] = useState<any[]>([]);
  const selectInp = useRef<any>(null);
  const selectAsset = useRef<any>(null);
  const [inpId, setInpId] = useState<any>(null);
  const [inpObjectType, setInpObjectType] = useState<any>(null);
  const [inpObjectId, setInpObjectId] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [canAddNeurals, setCanAddNeurals] = useState(false);
  const [imgUrl, setImgUrl] = useState<any>(null);
  const [showGraphModal, setShowGraphModal] = useState<boolean>(false);
  const [isUploadingHydroTwin, setIsUploadingHydroTwin] = useState(false);
  const timeoutRef = useRef<any>(null);
  const naDateOverridesStorageKey = `hydrotwin-na-dates:${digitalTwinData?.infrastructureId ?? 'unknown'}:${digitalTwinData?.parameterId ?? 'unknown'}`;
  const [naDateOverrides, setNaDateOverrides] = useState<{ ids: string[]; names: string[] }>({
    ids: [],
    names: [],
  });

  useEffect(() => {
    try {
      const storedValue = localStorage.getItem(naDateOverridesStorageKey);
      if (!storedValue) {
        setNaDateOverrides({ ids: [], names: [] });
        return;
      }

      const parsedValue = JSON.parse(storedValue);
      setNaDateOverrides({
        ids: Array.isArray(parsedValue?.ids) ? parsedValue.ids : [],
        names: Array.isArray(parsedValue?.names) ? parsedValue.names : [],
      });
    } catch {
      setNaDateOverrides({ ids: [], names: [] });
    }
  }, [naDateOverridesStorageKey]);

  useEffect(() => {
    localStorage.setItem(naDateOverridesStorageKey, JSON.stringify(naDateOverrides));
  }, [naDateOverrides, naDateOverridesStorageKey]);

  const resetHydroTwinModal = () => {
    setShowNewNeuralNetwork(false);
    setCurrentStep(1);
    setNewDigitalTwinData(null);
    setIsUploadingHydroTwin(false);
  };

  async function handleGetDigitalTwins(
    loading = true,
    overrides: { ids: string[]; names: string[] } = naDateOverrides,
  ) {
    const response = await digitalTwinService.getDigitalTwins(
      digitalTwinData.infrastructureId,
      digitalTwinData.parameterId,
      loading,
    );
    setCalibrations(applyNaDateOverrides(response || [], overrides));
  }

  async function handleDeleteDigitalTwin(id: any) {
    const response = await digitalTwinService.deleteDigitalTwin(id, digitalTwinData.parameterId);
    handleGetDigitalTwins();
  }

  async function handleGetGraph(id: string | number) {
    const response = await digitalTwinService.getTestModel(id);
    console.log(
      '🚀 ~ file: index.tsx:113 ~ handleGetGraph ~ response:',
      response,
    );
    setDataGraph(response);
    const seriesData = [
      {
        name: 'Neural Network Value',
        data: Object.keys(response.neuralNetworkValues)
          .map((item) => [
            parseFloat(`${item}000`),
            response.neuralNetworkValues[item],
          ])
          .sort((a, b) => {
            return a[0] - b[0];
          }),
      },
      {
        name: 'Historical value',
        data: Object.keys(response.testValues)
          .map((item) => [parseFloat(`${item}000`), response.testValues[item]])
          .sort((a, b) => {
            return a[0] - b[0];
          }),
      },
    ];
    console.log(
      '🚀 ~ file: index.tsx:135 ~ handleGetGraph ~ seriesData:',
      seriesData,
    );
    setGraphOptions({
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      chart: {
        type: 'line',
        zoomType: 'x',
        panKey: 'shift',
        height: 500,
        plotBorderWidth: 1,
      },
      xAxis: {
        type: 'datetime',
        ordinal: false,
      },
      plotOptions: { line: { marker: { enabled: false } } },
      tooltip: {
        valueDecimals: 2,
        split: false,
        shared: true,
        xDateFormat: '%Y-%m-%d %H:%M:%S',
      },
      navigator: {
        enabled: true,
      },
      legend: {
        enabled: true,
      },
      series: seriesData,
    });
    setShowNeuralGraph(true);
  }

  async function handleSetFavorite(id: string | number) {
    const response = await digitalTwinService.setFavoriteModel(id);
    handleGetDigitalTwins();
  }

  const handleGetModelInfraId = async () => {
    if (form.getFieldValue('inpId') && form.getFieldValue('inpObjectType')) {
      const response = await inpService.getModelInfrastructureId({
        inpId: form.getFieldValue('inpId'),
        typeId: form.getFieldValue('inpObjectType'),
      });
      setModelInfraIdList(response.data);
    }
  };

  const handleGetConfiguration = async () => {
    const res = await digitalTwinService.getConfiguration({
      paramId: digitalTwinData.parameterId,
      type: 'NN',
    });
    if (res) {
      form.setFieldsValue({
        inpId: `${res.inpId}`,
        inpObjectType: res.inpObjectType,
        inpObjectId: res.inpObjectId,
      });
      setInpId(res.inpId);
      setInpObjectType(res.inpObjectType);
      setInpObjectId(res.inpObjectId);
      if (selectInp.current) {
        selectInp.current.setValue({ inpId: res.inpId, label: 'asdas' });
      }
      setCanAddNeurals(true);
    }
  };

  const onFinish = async (values: any) => {
    const res = await digitalTwinService.postConfiguration({
      parameterId: digitalTwinData.parameterId,
      data: {
        inpId: parseInt(values.inpId),
        inpObjectType: values.inpObjectType,
        inpObjectId: values.inpObjectId,
      },
    });
    if (res) {
      setInpId(parseInt(values.inpId));
      setInpObjectType(values.inpObjectType);
      setInpObjectId(values.inpObjectId);
      notification.success({
        message: 'Successful',
        description: 'Configuration updated successfully',
      });
      setCanAddNeurals(true);
    }
  };

  const getObjectTypeLabel = (type: number | string | null) => {
    if (`${type}` === '1') {
      return 'Nodes';
    }
    if (`${type}` === '2') {
      return 'Links';
    }
    return '';
  };

  const serializeInputParameters = (variables: any[] = []) => {
    return Array.from(
      new Set(
        variables
          .map((item: any) => {
            const infraId = item?.infraId ?? item?.infrastructureId;
            const parameterId = item?.parameterId;

            if (infraId == null || parameterId == null) {
              return null;
            }

            return `${String(infraId).trim()}-${String(parameterId).trim()}`;
          })
          .filter(Boolean),
      ),
    ).join(',');
  };

  const formatTwinDate = (value?: string | null) => {
    if (!value) return 'NA';
    const parsedDate = dayjs(value);
    return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : 'NA';
  };

  const buildNaDateOverrides = (
    currentOverrides: { ids: string[]; names: string[] },
    params: {
      id?: string | number | null;
      name?: string | null;
    },
  ) => {
    const nextIds =
      params.id == null
        ? currentOverrides.ids
        : Array.from(new Set([...currentOverrides.ids, String(params.id)]));
    const normalizedName = String(params.name ?? '').trim().toLowerCase();
    const nextNames = !normalizedName
      ? currentOverrides.names
      : Array.from(new Set([...currentOverrides.names, normalizedName]));

    return {
      ids: nextIds,
      names: nextNames,
    };
  };

  const applyNaDateOverrides = (
    items: DigitalTwin[] = [],
    overrides: { ids: string[]; names: string[] } = naDateOverrides,
  ) => {
    return items.map((item: DigitalTwin) => {
      const normalizedName = String(item?.name ?? '').trim().toLowerCase();
      const shouldForceNaDates =
        overrides.ids.includes(String(item?.id)) ||
        overrides.names.includes(normalizedName);

      if (!shouldForceNaDates) {
        return item;
      }

      return {
        ...item,
        startDate: '',
        endDate: '',
      };
    });
  };

  const registerHydroTwinNaDates = (params: {
    id?: string | number | null;
    name?: string | null;
  }) => {
    setNaDateOverrides((prev) => buildNaDateOverrides(prev, params));
  };

  const getHydroTwinStatusLabel = (status?: string | null) => {
    return status == 'IN_PROGRESS'
      ? 'In Progress'
      : status == 'COMPLETED'
        ? 'Completed'
        : 'Failed';
  };

  const getHydroTwinProgressLabel = (item: DigitalTwin) => {
    if (item.status == 'IN_PROGRESS') {
      return `Executing ${item.progress ?? 0} %`;
    }

    if (item.status == 'COMPLETED') {
      return 'Completed 100%';
    }

    return 'Failed';
  };

  const resolveInpName = async (selectedInpId: number | string | null) => {
    if (!selectedInpId) {
      return '';
    }

    const response = await inpService.getModelFilesByOrganization({
      organizationId,
      locationId: digitalTwinData.locationId,
      page: 1,
      size: 1000,
      name: null,
    });

    const selectedInp = response?.inpFiles?.find(
      (item: any) => `${item.inpId}` === `${selectedInpId}`,
    );

    return selectedInp?.inpName || '';
  };

  const handleUploadHydroTwin = async (data: any) => {
    const currentInpId = form.getFieldValue('inpId') ?? inpId;
    const currentInpObjectType =
      form.getFieldValue('inpObjectType') ?? inpObjectType;
    const currentInpObjectId =
      form.getFieldValue('inpObjectId') ?? inpObjectId;

    if (
      currentInpId == null ||
      currentInpId === '' ||
      currentInpObjectType == null ||
      currentInpObjectType === '' ||
      currentInpObjectId == null ||
      currentInpObjectId === ''
    ) {
      notification.error({
        message: 'Missing configuration',
        description:
          'Please select Model File, Object Type, and Model Asset ID before uploading a HydroTwin.',
      });
      return;
    }

    try {
      setIsUploadingHydroTwin(true);
      
      const resolvedInpName = await resolveInpName(currentInpId);
      const inputParameters = serializeInputParameters(data?.variables || []);

      const uploadResponse = await digitalTwinService.uploadDigitalTwin({
        hydroTwinName: data?.name || '',
        inputParameters,
        assetId: `${digitalTwinData.infrastructureId}`,
        outputParam: `${digitalTwinData.infrastructureId}-${digitalTwinData.parameterId}`,
        inpId: Number(currentInpId),
        inpName: resolvedInpName || `${currentInpId}`,
        objectType: getObjectTypeLabel(currentInpObjectType),
        objectModelId: `${currentInpObjectId}`,
        h5File: data?.h5File,
        hdhtFile: data?.hdhtFile,
      });

      const nextOverrides = buildNaDateOverrides(naDateOverrides, {
        id:
          uploadResponse?.id ??
          uploadResponse?.neuralNetworkId ??
          uploadResponse?.data?.id ??
          uploadResponse?.data?.neuralNetworkId,
        name: data?.name,
      });
      registerHydroTwinNaDates({
        id:
          uploadResponse?.id ??
          uploadResponse?.neuralNetworkId ??
          uploadResponse?.data?.id ??
          uploadResponse?.data?.neuralNetworkId,
        name: data?.name,
      });

      notification.success({
        message: 'Successful',
        description: 'HydroTwin uploaded successfully',
      });

      await handleGetDigitalTwins(true, nextOverrides);
      resetHydroTwinModal();
    } catch (error: any) {
      notification.error({
        message: 'Upload failed',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Unable to upload the HydroTwin.',
      });
    } finally {
      setIsUploadingHydroTwin(false);
    }
  };

  const handleUpdateUploadedHydroTwin = async (data: any) => {
    if (!data?.neuralNetworkId) {
      notification.error({
        message: 'Missing HydroTwin',
        description: 'Unable to identify the HydroTwin to update.',
      });
      return;
    }

    try {
      setIsUploadingHydroTwin(true);

      await digitalTwinService.updateUploadDigitalTwin(data.neuralNetworkId, {
        h5File: data?.h5File,
        hdhtFile: data?.hdhtFile,
      });

      const nextOverrides = buildNaDateOverrides(naDateOverrides, {
        id: data?.neuralNetworkId,
        name: data?.name ?? newDigitalTwinData?.name,
      });
      registerHydroTwinNaDates({
        id: data?.neuralNetworkId,
        name: data?.name ?? newDigitalTwinData?.name,
      });

      notification.success({
        message: 'Successful',
        description: 'HydroTwin files updated successfully',
      });

      await handleGetDigitalTwins(true, nextOverrides);
      resetHydroTwinModal();
    } catch (error: any) {
      notification.error({
        message: 'Update failed',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Unable to update the HydroTwin files.',
      });
    } finally {
      setIsUploadingHydroTwin(false);
    }
  };

  async function handleGetInitialData() {
    try {
      await handleGetDigitalTwins();
      await handleGetConfiguration();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    handleGetInitialData();
  }, []);

  useEffect(() => {
    if (calibrations.findIndex((c) => c.status == 'IN_PROGRESS') >= 0) {
      timeoutRef.current = setTimeout(() => {
        handleGetDigitalTwins(false);
      }, 5000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [calibrations]);

  return !isLoading ? (
    <>
      <div style={{ padding: '0px 3rem' }}>
        <Button
          type="text"
          shape="round"
          className="flex items-center"
          style={{ backgroundColor: '#F7F9FA', color: '#434B56' }}
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowLeftOutlined rev={undefined} /> Back to Parameter
        </Button>
        <div className="flex column pt-2">
          <span className="text-title-page">
            {digitalTwinData.parameterName || 'Param name'}
          </span>
          <div style={{ color: '#023E65' }} className="pt-2 mb-2">
            <EnvironmentOutlined
              style={{ fontSize: '1.3rem' }}
              rev={undefined}
            />
            <span style={{ fontSize: '1.1rem' }} className="ml-1">
              {digitalTwinData.locationName || 'Location'}
            </span>
          </div>
          <Form
            form={form}
            layout="vertical"
            autoComplete="off"
            size="small"
            onFinish={onFinish}
            onFinishFailed={() => {}}
          >
            <div className="form-configuration-container">
              <Form.Item
                label="Model File"
                name="inpId"
                rules={[
                  { required: true, message: 'Please select an option' },
                  {
                    validator: (_, value) =>
                      value !== 0
                        ? Promise.resolve()
                        : Promise.reject(new Error('Please select an option')),
                  },
                ]}
              >
                <SelectInpFile
                  ref={selectInp}
                  defaultValue={parseInt(form.getFieldValue('inpId'))}
                  locationId={digitalTwinData.locationId}
                  requireLocation={true}
                  onSelect={(val: any) => {
                    form.setFieldValue('inpObjectId', null);
                    form.setFieldValue('inpId', val);
                    setInpId(val);
                    setInpObjectId(null);
                  }}
                  organizationId={organizationId}
                />
              </Form.Item>

              <Form.Item
                label="Object Type"
                name="inpObjectType"
                rules={[
                  { required: true, message: 'Please select a Object Type' },
                  {
                    validator: (_, value) =>
                      value !== 0
                        ? Promise.resolve()
                        : Promise.reject(new Error('Please select an option')),
                  },
                ]}
              >
                <Select
                  style={{ width: '100%' }}
                  placeholder="Select an option"
                  onChange={(val) => {
                    form.setFieldValue('inpObjectId', null);
                    setInpObjectType(val);
                    setInpObjectId(null);
                  }}
                  options={[
                    { value: 1, label: 'Nodes' },
                    { value: 2, label: 'Links' },
                  ]}
                />
              </Form.Item>
              <Form.Item
                label="Model Asset ID"
                name="inpObjectId"
                rules={[
                  {
                    required: true,
                    message: 'Please enter a Model Asset ID',
                  },
                  {
                    validator: (_, value) =>
                      value !== 0
                        ? Promise.resolve()
                        : Promise.reject(new Error('Please select an option')),
                  },
                ]}
              >
                <SelectAsset
                  ref={selectAsset}
                  inpId={inpId}
                  typeId={inpObjectType}
                  defaultValue={inpObjectId}
                  onSelect={(value: any) => {
                    form.setFieldValue('inpObjectId', value);
                    setInpObjectId(value);
                  }}
                />
              </Form.Item>
            </div>
            <Button
              style={{
                width: '85px',
                height: '40px',
                backgroundColor: '#00203C',
                color: 'white',
              }}
              htmlType="submit"
            >
              Save
            </Button>
          </Form>
          <div className="flex justify-end gap-3 mb-3">
            <Button
              disabled={!canAddNeurals}
              type="primary"
              shape="round"
              icon={<PlusCircleOutlined rev={undefined} />}
              className="flex items-center"
              style={{
                backgroundColor: '#023E65',
                color: 'white',
                width: '170px',
                height: '40px',
              }}
              onClick={() => {
                setCurrentStep(1);
                setNewDigitalTwinData(null);
                setShowNewNeuralNetwork(true);
              }}
            >
              Add HydroTwin
            </Button>
            <Button
              disabled={!canAddNeurals}
              type="primary"
              shape="round"
              icon={<PlusCircleOutlined rev={undefined} />}
              className="flex items-center"
              style={{
                backgroundColor: '#023E65',
                color: 'white',
                width: '190px',
                height: '40px',
              }}
              onClick={() => {
                setCurrentStep(0);
                setNewDigitalTwinData(null);
                setShowNewNeuralNetwork(true);
              }}
            >
              Upload HydroTwin
            </Button>
          </div>
          <div style={{ height: 'calc(100vh - 410px)', overflow: 'auto' }}>
            <div className="w-full card-calibration-display__container">
              {calibrations.map((item: DigitalTwin) => (
                <Card
                  key={item.id}
                  cover={
                    <div
                      className="flex items-center justify-between"
                      style={{
                        padding: '1.5rem',
                        borderBottom: '1px solid #C4CCD5',
                      }}
                    >
                      <div className="flex column">
                        <div>
                          <span
                            className="mr-2"
                            style={{ fontSize: '24px', fontWeight: 'bold' }}
                          >
                            {item.name}
                          </span>
                          <Tooltip
                            title={getHydroTwinStatusLabel(item.status)}
                          >
                            <Badge
                              color={
                                item.status == 'COMPLETED'
                                  ? 'green'
                                  : item.status == 'FAILED'
                                    ? 'red'
                                    : 'orange'
                              }
                            />
                          </Tooltip>
                        </div>
                        <span>{getHydroTwinProgressLabel(item)}</span>
                        <div className="flex">
                          {item.loss != null && (
                            <div
                              className="flex mr-2"
                              style={{ alignItems: 'center' }}
                            >
                              <span className="mr-1">loss: {item.loss}</span>
                              {item.lossGraph != null && (
                                <Tooltip title="See Graph">
                                  <EyeOutlined
                                    className="ml-1"
                                    style={{
                                      fontSize: '24px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      setImgUrl(item.lossGraph);
                                      setShowGraphModal(true);
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </div>
                          )}
                          {item.accuracy != null && (
                            <div
                              className="flex"
                              style={{ alignItems: 'center' }}
                            >
                              <span className="mr-1">acc: {item.accuracy}</span>
                              {item.accuracyGraph != null && (
                                <Tooltip title="See Graph">
                                  <EyeOutlined
                                    className="ml-1"
                                    style={{
                                      fontSize: '24px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      setImgUrl(item.accuracyGraph);
                                      setShowGraphModal(true);
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{ alignSelf: 'start' }}>
                        {item.status == 'COMPLETED' && (
                          <LineChartOutlined
                            className="mr-1 cursor-pointer"
                            onClick={() => {
                              handleGetGraph(item.id);
                            }}
                            rev={undefined}
                          />
                        )}
                        <Tooltip title="Update Files">
                          <UploadOutlined
                            className="mr-1 cursor-pointer"
                            onClick={() => {
                              setNewDigitalTwinData({
                                updateMode: true,
                                neuralNetworkId: item.id,
                                name: item.name,
                              });
                              setCurrentStep(3);
                              setShowNewNeuralNetwork(true);
                            }}
                            rev={undefined}
                          />
                        </Tooltip>
                        {item.principal ? (
                          <StarFilled
                            className="mr-1 cursor-pointer"
                            rev={undefined}
                          />
                        ) : (
                          <StarOutlined
                            className="mr-1 cursor-pointer"
                            onClick={() => {
                              handleSetFavorite(item.id);
                            }}
                            rev={undefined}
                          />
                        )}
                        <DeleteOutlined
                          className="mr-1 cursor-pointer"
                          onClick={() => {
                            handleDeleteDigitalTwin(item.id);
                          }}
                          rev={undefined}
                        />
                      </div>
                    </div>
                  }
                  style={{ maxWidth: '400px' }}
                >
                  <div className="card-calibration-content__container">
                    <div>Start Date</div>
                    <div>{formatTwinDate(item.startDate)}</div>
                    <div>End Date</div>
                    <div>{formatTwinDate(item.endDate)}</div>
                    <div>Input Params</div>
                    <div>{item.inputParams}</div>
                    <div>Output Params</div>
                    <div>{item.outputParam}</div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ModalAnt
        title=""
        open={showNewNeuralNetwork}
        footer={null}
        onCancel={() => {
          resetHydroTwinModal();
        }}
        style={{ width: 600 }}
        width={600}
      >
        {currentStep === 0 ? (
          <UploadHydroTwinStep
            digitalTwinData={digitalTwinData}
            onNext={(data: any) => {
              setNewDigitalTwinData({ ...data, uploadMode: true });
              setCurrentStep(3);
            }}
            onCancel={() => {
              resetHydroTwinModal();
            }}
          />
        ) : currentStep === 3 ? (
          <UploadHydroTwinFilesStep
            initialData={newDigitalTwinData}
            loading={isUploadingHydroTwin}
            onNext={(data: any) => {
              if (newDigitalTwinData?.updateMode) {
                handleUpdateUploadedHydroTwin(data);
                return;
              }
              handleUploadHydroTwin(data);
            }}
            onBack={() => {
              if (newDigitalTwinData?.updateMode) {
                resetHydroTwinModal();
                return;
              }
              setCurrentStep(0);
            }}
            onCancel={() => {
              resetHydroTwinModal();
            }}
          />
        ) : currentStep === 1 ? (
          <Step1
            digitalTwinData={digitalTwinData}
            initialData={newDigitalTwinData}
            onSaved={(data: any) => {
              setCurrentStep(2);
              setNewDigitalTwinData(data);
            }}
            onBack={() => {
              if (newDigitalTwinData?.uploadMode) {
                setCurrentStep(3);
                return;
              }
              setShowNewNeuralNetwork(false);
            }}
            onCancel={() => {
              resetHydroTwinModal();
            }}
          />
        ) : (
          <Step2
            digitalTwinData={digitalTwinData}
            newDigitalTwinData={newDigitalTwinData}
            onSaved={() => {
              handleGetDigitalTwins();
              resetHydroTwinModal();
            }}
            onBack={() => {
              setCurrentStep(1);
            }}
            onCancel={() => {
              resetHydroTwinModal();
            }}
          />
        )}
      </ModalAnt>
      <ModalAnt
        open={showNeuralGraph}
        footer={null}
        onCancel={() => setShowNeuralGraph(false)}
      >
        <ArrowLeftOutlined
          onClick={() => {
            setShowNeuralGraph(false);
          }}
          rev={undefined}
        />
        <div className="flex">
          <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            options={graphOptions}
            className={'chart-container'}
          />
        </div>
      </ModalAnt>
      <ModalAnt
        title=""
        open={showGraphModal}
        footer={[]}
        onCancel={() => {
          setShowGraphModal(false);
        }}
        className="modalImg"
      >
        <div className="" style={{ width: '100%', height: '100%' }}>
          <img src={imgUrl} alt="" style={{ width: '100%', height: '100%' }} />
        </div>
      </ModalAnt>
    </>
  ) : (
    <>
      <div></div>
    </>
  );
}

function mapState(state: { digitalTwin: { data: any } }) {
  return {
    digitalTwinData: state.digitalTwin.data,
  };
}

export default connect(mapState)(ParamSelfCalibrationView);
